import { render, staticRenderFns } from "./mathtestcomponent.vue?vue&type=template&id=49a507d9&scoped=true&"
import script from "./mathtestcomponent.vue?vue&type=script&lang=js&"
export * from "./mathtestcomponent.vue?vue&type=script&lang=js&"
import style0 from "./mathtestcomponent.vue?vue&type=style&index=0&id=49a507d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a507d9",
  null
  
)

export default component.exports